import React, { useEffect, useState } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import { LoginForm, StorageHandler } from 'C4';

import { googleStore, appleStore, storageKeys } from 'settings';
import apple from 'assets/images/app_store.png';
import google from 'assets/images/google_play.png';

const MobileButtons = () => (
  <div className="button__container">
    <div className="buttons small">
      <a href={appleStore} target="_blank" rel="noopener noreferrer">
        <img src={apple} alt="App store" />
      </a>
      <a href={googleStore} rel="noopener noreferrer" target="_blank">
        <img src={google} alt="Google Play" />
      </a>
    </div>
  </div>
);

const LoginView = (props) => {
  const [logo, setLogo] = useState(null);
  const [loginImage, setLoginImage] = useState(null);

  const getAppInfo = async () => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      setLogo(appInfo.logo);
      setLoginImage(appInfo.loginImage);
    }
  };

  useEffect(() => {
    getAppInfo();
  });

  return (
    <div className="loginView">
      <div
        className="loginView__bg"
        style={{
          backgroundImage: `linear-gradient(transparent,rgba(0,0,0,.7)), url(${loginImage})`,
        }}
      >
        <div className="loginView__bg--content">
          <div className="buttonWrapper">
            {i18n.translate('loginScreen.version2.store')}
            <MobileButtons />
          </div>
          <div className="poweredBy">
            {i18n.translate('loginScreen.version2.powered')}
          </div>
          <img
            src="https://front.travpromobile.com/logos/logo_white.png"
            className="loginView__content--logo"
            alt="Logo"
          />
        </div>
      </div>
      <div className="loginView__content">
        <img src={logo} className="loginView__content--logo" alt="Logo" />
        <LoginForm path={props.match.path} />
      </div>
      <style>
        {
          '\
          #openWidget { width: 23rem; display: block; top: 2rem; bottom: unset; right: 2rem;  border-radius: 5rem !important; } #openWidget:after {display: none; }    '
        }
      </style>

      {window.location.pathname.includes('mobile') && (
        <style>
          {
            '\
            .loginView__content { display: block !important; } .buttonWrapper { display: none !important; }.loginView__bg--content { display: none; } .mt-1 { margin-top: 2.5rem } input { font-size: 16px !important; } .loginView__content { width: 100% !important; opacity: 1 !important; } .buttonWrapper { display:none !important; } .loginView__content--logo { display: none !important; } .btnInverse { display: none !important; } .cookieConsent { display: none; bottom: 4rem; } .register { display: none !important; } .loginView .loginView__bg .loginView__bg--content .buttonWrapper img { display: none !important; }  #openWidget { display: none !important; } .loginView__bg { display: none !important; } .loginView { display:block !important; }'
          }
        </style>
      )}
    </div>
  );
};

export default LoginView;

LoginView.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
};

LoginView.defaultProps = {
  match: {
    path: '/login',
  },
};
